import {
	TOGGLE_AUTHENTICATE_MODAL,
} from "../app/ActionTypes";

/* Initial state */
const initialState = {
	showAuthenticateModal: false,
};

/* Reducer */
export default function authenticate(state = initialState, action) {
	switch (action.type) {
		case TOGGLE_AUTHENTICATE_MODAL:
			return {
				...state,
				showAuthenticateModal: !state.showAuthenticateModal
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/js/authenticate/authenticateReducer.js